module.exports = __webpack_public_path__ + "img/success-delivery-m.9dd0dc19.svg";